export default __webpack_public_path__ + "static/media/ic-itau-cultural-branco.png.4a3c14be.svg";